import { ProjectDocumentDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProjectDocument = createAction(
  '[ProjectDocument] Load ProjectDocument'
);

export const loadProjectDocumentSuccess = createAction(
  '[ProjectDocument] Load ProjectDocument Success',
  props<{ projectDocument: ProjectDocumentDto[] }>()
);

export const loadProjectDocumentFailure = createAction(
  '[ProjectDocument] Load ProjectDocument Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addProjectDocument = createAction(
  '[ProjectDocument] Add ProjectDocument',
  props<{ newProjectDocument: ProjectDocumentDto[] }>()
);

export const addProjectDocumentSuccess = createAction(
  '[ProjectDocument] Add ProjectDocument Success',
  props<{ newProjectDocument: ProjectDocumentDto[] }>()
);

export const addProjectDocumentFailure = createAction(
  '[ProjectDocument] Add ProjectDocument Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchProjectDocumentRecord = createAction(
  '[ProjectDocument] Search  ProjectDocument Record',
  props<{ query: string }>()
);

/**
 * Update ProjectDocument Collection Actions
 */
export const updateProjectDocument = createAction(
  '[ProjectDocument] Update ProjectDocument',
  props<{ updateProjectDocument: ProjectDocumentDto[] }>()
);

export const updateProjectDocumentSuccess = createAction(
  '[ProjectDocument] Update ProjectDocument Success',
  props<{ updateProjectDocument: ProjectDocumentDto[] }>()
);

export const updateProjectDocumentFailure = createAction(
  '[ProjectDocument] Update ProjectDocument Failure',
  props<{ error: any }>()
);

/**
 * Remove ProjectDocument Collection Actions
 */
export const removeProjectDocument = createAction(
  '[ProjectDocument] Remove ProjectDocument',
  props<{ ids: string[] }>()
);

export const removeProjectDocumentSuccess = createAction(
  '[ProjectDocument] Remove ProjectDocument Success',
  props<{ ids: string[] }>()
);

export const removeProjectDocumentFailure = createAction(
  '[ProjectDocument] Remove ProjectDocument Failure',
  props<{ error: any }>()
);
